import { RESULT_BACKGROUNDS, RESULT_RATIOS } from "../resultAssets";
import {TEXT_STYLES} from "../resultTheme";
import {
    COMMON_NIGHT_ZONES,
    DEFAULT_POST_TYPOGRAPHY,
    MT_DAY_ZONES,
    createStandardLayout, NIGHT_A_GROUP,
} from "./sharedLayouts";


 const MT_DAY_POST_AREA = {
    frame: { left: 11.5, width: 33.5 },
    rows: {
        startTop: 25.2,
        rowHeight: 6.65,
    },
};


 const MT_NIGHT_POST_AREA = {
    frame: { left: 12, width: 33.5 },
    rows: {
        startTop: 45.38,
        rowHeight: 8.6,
    },
};


const DAY_LO_LAYOUT = {
    rowGap: "1.7%",
    columnGap: "3%",
    columns: 2,
};

const NIGHT_LO_LAYOUT = {
    rowGap: "1.2%",
    columnGap: "3%",
    columns: 2,
};



export const mtConfig = {
    bg: RESULT_BACKGROUNDS.MT,
    layout: {
        DAY: createStandardLayout({
            ratio: RESULT_RATIOS.MT.DAY,
            zones: MT_DAY_ZONES,
            postArea: MT_DAY_POST_AREA,
            postCodes: ["A", "B", "C", "D", "F", "I", "N", "K"],
            postTypography: DEFAULT_POST_TYPOGRAPHY,
            loLayout: DAY_LO_LAYOUT,
            textStyle: TEXT_STYLES.mt,
        }),
        NIGHT: createStandardLayout({
            ratio: RESULT_RATIOS.MT.NIGHT,
            zones: COMMON_NIGHT_ZONES,
            postArea: MT_NIGHT_POST_AREA,
            postTypography: DEFAULT_POST_TYPOGRAPHY,
            loLayout: NIGHT_LO_LAYOUT,
            aGroup: NIGHT_A_GROUP,
            textStyle: TEXT_STYLES.mtNight,
        }),
    },
};
